/**
 * Filing Status Badge Component
 *
 * Displays a colored badge indicating the filing status.
 *
 * Session 3.2: Filing History Frontend
 */

import type { FilingStatus } from '@/types/filing';
import { getStatusConfig } from '@/types/filing';

interface FilingStatusBadgeProps {
  /** Filing status */
  status: FilingStatus;
  /** Optional size variant */
  size?: 'sm' | 'md';
}

/**
 * Status badge with color coding.
 * - GENERATED: Amber (pending action)
 * - FILED: Green (completed)
 * - AMENDED: Blue (modified)
 */
export function FilingStatusBadge({
  status,
  size = 'md',
}: FilingStatusBadgeProps) {
  const config = getStatusConfig(status);

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
  };

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full border ${config.bgColor} ${config.textColor} ${config.borderColor} ${sizeClasses[size]}`}
    >
      {config.label}
    </span>
  );
}
